import React, { useContext } from 'react';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../componentsInternal/WithTitle';
import { useTranslation } from '../hooks/useTranslation';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import { useSearchPageData } from '../hooksInternal/useSearchPageData';
import ErrorPage from './error';
const SearchPage = ({}) => {
    var _a;
    const { t } = useTranslation();
    usePageClassName('search-page');
    const { fetchingStatus, searchTerm } = useSearchPageData();
    const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);
    if (fetchingStatus === 'is-fetching' || fetchingStatus === 'not-started')
        return React.createElement(Loader, null);
    if (fetchingStatus !== 'has-fetched')
        return React.createElement(ErrorPage, null);
    const title = t('pageTitles.search', { searchTerm });
    const Page = (_a = pages.search) === null || _a === void 0 ? void 0 : _a.component;
    const searchPage = Page ? React.createElement(Page, null) : React.createElement(React.Fragment, null);
    return React.createElement(WithTitle, { title: title }, searchPage);
};
SearchPage.displayName = 'SearchPage';
export default SearchPage;
//# sourceMappingURL=search.js.map